const NOT_AUTHORIZED = 'NOT_AUTHORIZED';

export default NOT_AUTHORIZED;

export { NOT_AUTHORIZED };
